






















import {Component, Prop, Vue} from 'vue-property-decorator';
import TabBreadcrumbItem from './TabBreadcrumbItem.vue';

@Component({
    components: {TabBreadcrumbItem},
})

export default class TabNav extends Vue {
    @Prop({type: Array, required: true}) private readonly tabs!: string[];
    @Prop(String) private readonly activeClass!: string;
}
